import type { MultichainConfig } from 'types/multichain';

let value: MultichainConfig | undefined = undefined;

function readFileConfig() {
  // eslint-disable-next-line no-restricted-properties
  if (typeof window !== 'undefined' || process.env.NEXT_RUNTIME !== 'nodejs') {
    // 在瀏覽器環境中返回 undefined
    return undefined;
  }

  try {
    // 只在 Node.js 環境中動態引入模組
    const path = require('path');
    const { readFileSync } = require('fs');
    const publicFolder = path.resolve('public');
    const configPath = path.resolve(publicFolder, 'assets/multichain/config.json');

    const config = readFileSync(configPath, 'utf8');

    value = JSON.parse(config) as MultichainConfig;
    return value;
  } catch (error) {
    return;
  }
}

export async function load() {
  // 在瀏覽器環境中直接返回 undefined
  if (typeof window !== 'undefined') {
    return Promise.resolve(undefined);
  }

  if (!value) {
    return new Promise<MultichainConfig | undefined>((resolve) => {
      const value = readFileConfig();
      resolve(value);
    });
  }

  return Promise.resolve(value);
}

export function getValue() {
  // 在瀏覽器環境中直接返回 undefined
  if (typeof window !== 'undefined') {
    return undefined;
  }

  if (!value) {
    return readFileConfig();
  }

  return value;
}
